import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { AppBarProps } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation } from 'react-router-dom';
import NavbarCatgories from './NavbarCategories';
import NavbarPersonal from './NavbarPersonal';
import NavbarLogo from './NavbarLogo';
import { useLayout } from 'contexts/layoutContext';
import NavbarSearchArea from './NavbarSearchArea';

type DashboardNavbarPropsT = AppBarProps & {
  // onToggleSidebar?: () => void;
};

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  ...(theme.palette.mode === 'light'
    ? {
        boxShadow: theme.shadows[3],
      }
    : {
        backgroundColor: theme.palette.background.paper,
        borderBottomColor: theme.palette.divider,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        boxShadow: 'none',
      }),
}));

function DashboardNavbar(props: DashboardNavbarPropsT) {
  const { ...other } = props;
  const { pathname } = useLocation();
  const { toggleSidebarOpen } = useLayout();

  const pagesWithoutTopBar = [
    '/user/start',
    '/user/welcome',
    '/user/signIn',
    '/user/signUp',
    '/user/agreement',
    '/user/agreementDetail',
    '/user/selectRole',
    '/user/verifyPhone',
  ];

  if (pagesWithoutTopBar.includes(pathname)) return null;

  return (
    <DashboardNavbarRoot
      color="default"
      sx={{
        left: 0,
        width: '100%',
        zIndex: 1101, // drawer 1100 보다 1 큼
      }}
      {...other}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 64,
          left: 0,
          px: 2,
        }}
      >
        <IconButton
          onClick={toggleSidebarOpen}
          sx={{
            display: {
              xs: 'inline-flex',
              // lg: 'none',
            },
            mr: 2,
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <NavbarLogo />
        <NavbarCatgories />
        <Box sx={{ flexGrow: 1 }} />
        <NavbarSearchArea />
        <NavbarPersonal />
      </Toolbar>
    </DashboardNavbarRoot>
  );
}

export default DashboardNavbar;
